import es from 'date-fns/locale/es';
import React, { Component } from 'react';
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import '../common/MdPage.css';
import { LookupMaterias } from '../MateriaCarrera/LookupMaterias';
import { ChevronLeftIcon } from '../common/mdPageIcons';
import * as constantClass from '../fileWithConstants';
import Select from '../common/AppSelect';
import * as correlatividadesService from '../../services/correlatividades/correlatividadesService';
import { classifyCorrelatividadesError, toSaveCorrelatividadRendirPayload } from '../../services/correlatividades/correlatividadesDto';

const optionsCuatrimestre = [
  { value: 'A', label: 'Aprobada' },
  { value: 'R', label: 'Regular' }
];

registerLocale('es', es)

export class AddCorrelatividadRendir extends Component {
  static displayName = AddCorrelatividadRendir.name;
   

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showErrorMessage: false,
      success: false,
      errorMessage: "",
      showLookupAnios: false,
      showCursada: false,
      tagDataAlumno: [{ id: "", text: "" }],
      tagDataCursada: [{ id: "", text: "" }],
      materiaInicial: { codigo: "", descripcion: "" },
      materiaCorrelativa: { codigo: "", descripcion: "" },
      cursada: { codigo: "", descripcion: "" },
      startDate: new Date(),
      endDate: new Date(),
      startInscriptionDate: new Date(),
      endInscriptionDate : new Date(),
      carreraCursada: -1,
      materiaCodigo: "",
      valueDictado: { value: '', label: '' },
      tagData: [{ id: "", text: "", materiaCarreraCod3:""}],
      materiaCarreraCod3: "",
      ignorarCorrelatividad: false,
      ignorarRegularidad: false
    };
    this.handleConfirmButton = this.handleConfirmButton.bind(this);
    this.handleShowAniosLookup = this.handleShowAniosLookup.bind(this);
    this.handleSelectAnioItem = this.handleSelectAnioItem.bind(this);
    this.handleHideLookup = this.handleHideLookup.bind(this);
    this.handleShowCursadaLookup = this.handleShowCursadaLookup.bind(this);
    this.handleSelectCursadaItem = this.handleSelectCursadaItem.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleHideLookup1 = this.handleHideLookup1.bind(this);
    this.handleDictadoChangeInput = this.handleDictadoChangeInput.bind(this);
    this.handleCheckBoxCorrelatividad = this.handleCheckBoxCorrelatividad.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  handleConfirmButton = () => {
    var isOkToSave = this.isOkToSave(); 
  
    if (!isOkToSave) {
      this.setState({ showErrorMessage: true, errorMessage: "Todos los campos son obligatorios" });
    } else
    {
      this.saveStudent();
    }
  }

  async componentDidMount() {
    await constantClass.canAccess('WWCorrelatividadesRendir');
  }

  handleDelete = (i) => {
    this.setState({ tagData: this.state.tagData.filter(tag => tag.id !== i) });
  }

  handleDictadoChangeInput = e => {
    this.setState({ dictado: e.value, valueDictado: e });
  }

  handleChange = (e) => {
    this.setState({ llamado: e.value });
  }

  handleDelete = (i) => {
    this.setState({ tagDataAlumno: this.state.tagDataAlumno.filter(tag => tag.id !== i), carreraCursada: -1});
  }

  handleDeleteCursada = (i) => {
    this.setState({ tagDataCursada: this.state.tagDataCursada.filter(tag => tag.id !== i) });
  }

  handleShowAniosLookup = () => {
    this.setState({ showLookupAnios: true });
  }

  handleShowCursadaLookup = () => {
    this.setState({ showCursada: true });
  }

  handleHideLookup = () => {
    this.setState({ showLookupAnios: false });
  }
  handleHideLookup1 = () => {
    this.setState({ showCursada: false });
  }

  handleLlamadoChangeInput = e => {
    this.setState({ llamado: e.target.value });
  }

  handleSelectAnioItem = (e) => {
    const carreraProperties = e.split('%');
    this.setState({
      showLookupAnios: false,
      carreraCursada: Number(carreraProperties[3]),
      materiaInicial: {
        codigo: carreraProperties[0],
        descripcion: carreraProperties[1] + " - " + carreraProperties[2]
      }
    });
  }

  handleSelectCursadaItem = (e) =>
  {
    const carreraProperties = e.split('%');
    this.setState({
      showLookupAnios: false,
      carreraCursada: Number(carreraProperties[3]),
      materiaCorrelativa: {
        codigo: carreraProperties[0],
        descripcion: carreraProperties[1] + " - " + carreraProperties[2]
      }
    });
    
  }

  handleCheckBoxCorrelatividad = (e) => {
    this.setState({ ignorarCorrelatividad: e.target.checked });
  }

  handleCheckBoxRegularidad = (e) => {
    this.setState({ ignorarRegularidad: e.target.checked });
  }

  render() {
    if (this.state.success) {
      return <Redirect to="/md-crendir" />;
    }

    const { loading } = this.state;
    const canSelectCorrelativa = !loading && this.state.carreraCursada !== -1;

    return (
      <div className="md-page md-add-crendir">
        <Link className="md-page__back-link" to="/md-crendir">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 className="md-page__title">Nuevo Correlatividad para Rendir</h1>
        </div>
        <p className="md-page__subtitle">
          Seleccione la materia, la correlativa y la condición de inscripción.
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
          {loading ? (
            <div className="md-page__status">Los datos se está guardando, espere unos segundos...</div>
          ) : null}
        </div>

        <div className="md-page__form-card">
          <div className="md-page__field">
            <span className="md-page__field-label">Materia</span>
            <div className="md-page__picker-block">
              {!loading ? (
                <button type="button" className="md-page__picker-link" onClick={this.handleShowAniosLookup}>
                  Seleccionar materia
                </button>
              ) : null}
              <div className="md-page__field-readonly">{this.state.materiaInicial.descripcion}</div>
            </div>
          </div>

          <div className="md-page__field">
            <span className="md-page__field-label">Correlativa</span>
            <div className="md-page__picker-block">
              {canSelectCorrelativa ? (
                <button type="button" className="md-page__picker-link" onClick={this.handleShowCursadaLookup}>
                  Seleccionar correlativa
                </button>
              ) : (
                <p className="md-page__file-hint">Seleccione la materia antes de seleccionar la correlativa.</p>
              )}
              <div className="md-page__field-readonly">{this.state.materiaCorrelativa.descripcion}</div>
            </div>
          </div>

          <div className="md-page__field">
            <span className="md-page__field-label">Condición de Inscripción</span>
            <Select
              className="md-page__field-select"
              value={this.state.valueDictado}
              options={optionsCuatrimestre}
              onChange={this.handleDictadoChangeInput}
              disabled={loading}
            />
          </div>

          <div className="md-page__form-actions">
            <button
              type="button"
              className="md-page__form-btn md-page__form-btn--primary"
              onClick={this.handleConfirmButton}
              disabled={loading}
            >
              Confirmar
            </button>
          </div>
        </div>

        {this.state.showLookupAnios ? (
          <LookupMaterias selectItem={this.handleSelectAnioItem} hideLookup={this.handleHideLookup} />
        ) : null}
        {this.state.showCursada ? (
          <LookupMaterias selectItem={this.handleSelectCursadaItem} hideLookup={this.handleHideLookup1} />
        ) : null}
      </div>
    );
  }

  isOkToSave() {
    return (this.state.materiaInicial.descripcion.length > 1 && this.state.valueDictado.value != "");
  }

  async saveStudent() {
    this.setState({ showErrorMessage: false, loading: true });
    try {
      await correlatividadesService.saveCorrelatividadRendir(
        toSaveCorrelatividadRendirPayload({
          materiaInicialCod: this.state.materiaInicial.codigo,
          materiaCorrelativaCod: this.state.materiaCorrelativa.codigo,
          condicion: this.state.valueDictado.value
        })
      );
      this.setState({ loading: false, success: true, errorMessage: "" });
    } catch (error) {
      const outcome = classifyCorrelatividadesError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      this.setState({ loading: false, success: false, errorMessage: outcome.message });
    }
  }
}
